import React, { useEffect } from "react";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import "../../../style/forms.scss";
import "../../../style/alerts.scss";
import { useNavigate } from "react-router";
import { LOGIN_PAGE } from "../../routes";
import { SubmitHandler, useForm } from "react-hook-form";
import { emailValidator } from "../../../utils/formsValidation";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { REMIND_PASSWORD_USER_URL } from "../../api/apiRoutes";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, setSuccessMessage } from "../../store/alerts/alertsActions";
import useFacility from "../../../utils/hooks/useFacility";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import { IoMdArrowRoundForward } from "react-icons/io";
import EATextField from "../shared/TextField/EATextField";
import EADivider from "../shared/EADivider";

type Inputs = {
  email: string;
};

const RemindPass: React.FC = () => {
  const navigate = useNavigate();
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const dispatch = useDispatch();
  const alertLogin = useSelector((state: State) => state.alerts.errors);
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const handleRemindPass: SubmitHandler<Inputs> = async (data) => {
    const { isError } = await post(REMIND_PASSWORD_USER_URL(facilityIds), { email: data.email });
    if (!isError) {
      dispatch(setSuccessMessage(t("haslo_zostalo_wyslane_na_podany_adres_email")));
    }
  };

  useEffect(() => {
    dispatch(clearErrors());
    //eslint-disable-next-line
  }, []);

  return (
    <div className="auth-page auth-thermal">
      {/* tło w stylu “termalnej mgiełki” */}
      <div className="thermal-blob b1" aria-hidden="true" />
      <div className="thermal-blob b2" aria-hidden="true" />
      <div className="thermal-wave" aria-hidden="true" />

      <div className="auth-shell flex-center-center">
        <div className="auth-box auth-glass shadow">
 <div className="header">
          <div className="badge" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2C12 2 5 10 5 14.5C5 18.09 8.134 21 12 21C15.866 21 19 18.09 19 14.5C19 10 12 2 12 2Z"
                stroke="#3aa5f8"
                strokeWidth="1.6"
              />
              <path
                d="M9 14.8c0 1.77 1.79 3.2 3 3.2 1.21 0 3-1.43 3-3.2"
                stroke="#3aa5f8"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <div className="title">
            <h1>{t("zapomnialem_hasla")}</h1>
              <p>{t("podaj_adres_email_podany_przy_rejestracji_na_ktory_zostanie_przeslane_nowe_haslo")}</p>
            </div>
        </div>

          {/* <div className="auth-head">
            <div className="auth-badge" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2C12 2 5 10 5 14.5C5 18.09 8.134 21 12 21C15.866 21 19 18.09 19 14.5C19 10 12 2 12 2Z"
                  stroke="#3aa5f8"
                  strokeWidth="1.6"
                />
                <path
                  d="M9 14.8c0 1.77 1.79 3.2 3 3.2 1.21 0 3-1.43 3-3.2"
                  stroke="#3aa5f8"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                />
              </svg>
            </div>

            <div className="auth-titles">
              <h1>{t("zapomnialem_hasla")}</h1>
              <p>{t("podaj_adres_email_podany_przy_rejestracji_na_ktory_zostanie_przeslane_nowe_haslo")}</p>
            </div>
          </div> */}

          <form onSubmit={handleSubmit(handleRemindPass)} className="auth-form">
            <div className="auth-fields">
              <EATextField
                label={"E-mail"}
                type="email"
                name="email"
                placeholder={"E-mail"}
                register={{ ...register("email", { ...emailValidator(true) }) }}
                fullWidth
                error={Boolean(errors.email)}
              />

              {alertLogin && alertLogin.length > 0 && (
                <div className="alert alert-red auth-alert">{alertLogin}</div>
              )}
            </div>

            <div className="auth-divider">
              <EADivider />
            </div>

            <div className="flex-between-center buttons auth-actions">
              <EAButton
                title={t("zaloguj_sie")}
                onClick={() => navigate(LOGIN_PAGE)}
                fullWidth
                variant="outlined"
              />
              <EAButton
                title={t("resetuj_haslo")}
                inputType="submit"
                endIcon={<IoMdArrowRoundForward />}
              />
            </div>

            <div className="auth-footnote">
              <span>{t("zapomnialem_hasla")}</span>
              <span className="dot" aria-hidden="true">•</span>
              <button type="button" className="linkish" onClick={() => navigate(LOGIN_PAGE)}>
                {t("zaloguj_sie")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RemindPass;
